const checkImageSize = async (file,source) => {
    return new Promise((resolve, reject) => {
      if (source === 'user') {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event) => {
          const image = new Image();
          image.src = event.target.result;
          image.onload = () => {
            resolve({ width: image.width, height: image.height });
          };
          reader.onerror = (err) => reject(err);
        };
      }else if (source === 'url'){
        const image = new Image();
        image.src = file;
        image.onload = () => {
          resolve({ width: image.width, height: image.height });
        };
      }else{
        resolve({ width: 900, height: 600 });
      }
      
    });
};

export default checkImageSize;